import React, { useState, useEffect } from 'react';
import {
    TextField, Button, Container, Typography, Grid, Box, Select, FormControl, InputLabel, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControlLabel, Checkbox
} from '@mui/material';
import InputMask from 'react-input-mask';
import buscarCEP from '../../utils/BuscarCEP';
import '../../App.css';
import logo from '../../assets/senai.svg';
import { Link } from 'react-router-dom';
import api from '../../services/api';


const Home = ({parceiro}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogMessage, setDialogMessage] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [cpfErro, setCpfErro] = useState(false);
    /*const [cursos, setCursos] = useState([]);*/
    const [turmas, setTurmas] = useState([]);

    const fetchCursos = async () => {
        /*try {
            const response = await api.get('/cursos/list?ativo=S'); // Faz a requisição para obter os cursos
            const cursosTemp = [{ id: 0, descricao: '[A ESCOLHER]' }, ...response.data];
            setCursos(cursosTemp);// Armazena os cursos no estado
        } catch (error) {
            console.error('Erro ao buscar cursos:', error);
        }*/ 

        try {
            const response = await api.get('/turmas/list?ativo=S&prazo=s'); // Faz a requisição para obter as turmas
            const turmasTemp = [{ id: 0, descricao: ' ' }, ...response.data];
            setTurmas(turmasTemp); // Armazena as turmas no estado
        } catch (error) {
            console.error('Erro ao buscar turmas:', error);
        }
    };

    useEffect(() => {
        fetchCursos(); // Chama a função para buscar os cursos e turmas quando o componente for carregado
    }, []);

    const vazio = {
        nomeCurso: '0',
        nomeTurma: '-1',
        nomeCivil: '',
        nomeSocial: '',
        dataNascimento: '',
        documentoIdentidade: '',
        orgao: '',
        ufDocumento: '',
        cpf: '',
        sexo: '',
        nacionalidade: '',
        naturalidade: '',
        ufNaturalidade: '',
        pai: '',
        mae: '',
        etnia: '',
        deficiencia: '',
        cep: '',
        rua: '',
        numero: '',
        bairro: '',
        municipio: '',
        estado: '',
        telefone: '',
        celular: '',
        email: '',
        responsavelLegal: '',
        cpfCnpjResponsavel: '',
        situacaoOcupacional: '',
        escolaridade: '',
        concluido: '',
        cursando: '',
        anoConclusao: '',
        serieCursando: '',
        escola: ''
    };

    const [formData, setFormData] = useState(vazio);

    const sexos = [
        { label: 'Feminino', value: 'F' },
        { label: 'Masculino', value: 'M' }
    ];

    const estados = [
        { label: 'Acre', value: 'AC' },
        { label: 'Alagoas', value: 'AL' },
        { label: 'Amapá', value: 'AP' },
        { label: 'Amazonas', value: 'AM' },
        { label: 'Bahia', value: 'BA' },
        { label: 'Ceará', value: 'CE' },
        { label: 'Distrito Federal', value: 'DF' },
        { label: 'Espírito Santo', value: 'ES' },
        { label: 'Goiás', value: 'GO' },
        { label: 'Maranhão', value: 'MA' },
        { label: 'Mato Grosso', value: 'MT' },
        { label: 'Mato Grosso do Sul', value: 'MS' },
        { label: 'Minas Gerais', value: 'MG' },
        { label: 'Pará', value: 'PA' },
        { label: 'Paraíba', value: 'PB' },
        { label: 'Paraná', value: 'PR' },
        { label: 'Pernambuco', value: 'PE' },
        { label: 'Piauí', value: 'PI' },
        { label: 'Rio de Janeiro', value: 'RJ' },
        { label: 'Rio Grande do Norte', value: 'RN' },
        { label: 'Rio Grande do Sul', value: 'RS' },
        { label: 'Rondônia', value: 'RO' },
        { label: 'Roraima', value: 'RR' },
        { label: 'Santa Catarina', value: 'SC' },
        { label: 'São Paulo', value: 'SP' },
        { label: 'Sergipe', value: 'SE' },
        { label: 'Tocantins', value: 'TO' }
    ];

    const etnias = [
        { label: 'Amarela', value: '1' },
        { label: 'Branca', value: '2' },
        { label: 'Indigena', value: '3' },
        { label: 'Negra', value: '4' },
        { label: 'Parda', value: '5' },
        { label: 'Não Declarante', value: '6' }
    ];

    const deficiencias = [
        { label: 'Não Possui', value: '1' },
        { label: 'Auditiva', value: '2' },
        { label: 'Física', value: '3' },
        { label: 'Visual', value: '4' },
        { label: 'Intelectual', value: '5' },
        { label: 'Múltipla', value: '6' },
        { label: 'Altas habilidades', value: '7' },
        { label: 'Consultas típicas', value: '8' },
        { label: 'Outras', value: '9' }
    ];

    const ocupacoes = [
        { label: 'Autônomo', value: '1' },
        { label: 'Empregado com carteira', value: '2' },
        { label: 'Empregado sem carteira', value: '3' },
        { label: 'Empregador', value: '4' },
        { label: 'Profissional Liberal', value: '5' },
        { label: 'Desempregado em busca 1° emprego', value: '6' },
        { label: 'Desempregado', value: '7' },
        { label: 'Aposentado', value: '8' },
    ];

    const niveisEnsino = [
        { label: 'Ensino Fundamental', value: '1' },
        { label: 'Ensino Médio', value: '2' },
        { label: 'Ensino Superior', value: '3' },
    ];

    const escolas = [
        { label: 'Estadual', value: '1' },
        { label: 'Municipal', value: '2' },
        { label: 'Particular', value: '3' },
        { label: 'SENAI', value: '4' },
        { label: 'SESI', value: '5' },
        { label: 'Federal', value: '6' },
    ];

    const validarCPF = (cpf, exibirMsg) => {
        cpf = cpf.replace(/[^\d]+/g, ''); // Remover caracteres não numéricos
        if (cpf.length !== 11) {
            return false;
        }

        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
            setCpfErro(true);
            if (exibirMsg) {
                setDialogTitle('Inválido');
                setDialogMessage('CPF inválido, verifique!');
                setDialogOpen(true);
            }
            return false;
        }

        let soma = 0;
        let resto;

        // Cálculo do primeiro dígito verificador
        for (let i = 1; i <= 9; i++) {
            soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }

        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) {
            setCpfErro(true);
            if (exibirMsg) {
                setDialogTitle('Inválido');
                setDialogMessage('CPF inválido, verifique!');
                setDialogOpen(true);
            }
            return false;
        }

        soma = 0;

        // Cálculo do segundo dígito verificador
        for (let i = 1; i <= 10; i++) {
            soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }

        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) {
            setCpfErro(true);
            if (exibirMsg) {
                setDialogTitle('Inválido');
                setDialogMessage('CPF inválido, verifique!');
                setDialogOpen(true);
            }
            return false;
        }

        setCpfErro(false);
        return true;
    };

    const limparFormulario = () => {
        setFormData(vazio);
    }


    const handleChange = (e) => {
        let { name, type, checked, value } = e.target;

        if (typeof value === 'string') {
            value = value.toUpperCase();
        }

        if (type === 'checkbox') {
            // Se for um checkbox, usamos o 'checked' para capturar se está marcado ou não
            setFormData({
                ...formData,
                [name]: checked
            });
        } else {
            // Para os demais campos
            setFormData({
                ...formData,
                [name]: value // Mantém a transformação para uppercase
            });

            if (name === 'cpf') {
                validarCPF(value, false);
            }
        }
    };

    const handleCheckboxChange = (e, field) => {
        const isChecked = e.target.checked;
    
        if (field === 'concluido') {
            // Se marcar "Concluído", desmarca "Cursando"
            setFormData({
                ...formData,
                concluido: isChecked,
                cursando: !isChecked ? formData.cursando : false, // Desmarca o outro campo se marcado
                anoConclusao: isChecked ? formData.anoConclusao : '', // Reseta anoConclusao se desmarcar
                serieCursando: ''
            });
        } else if (field === 'cursando') {
            // Se marcar "Cursando", desmarca "Concluído"
            setFormData({
                ...formData,
                cursando: isChecked,
                concluido: !isChecked ? formData.concluido : false, // Desmarca o outro campo se marcado
                serieCursando: isChecked ? formData.serieCursando : '', // Reseta serieCursando se desmarcar
                anoConclusao: ''
            });
        }
    };


    const handleCepChange = async (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (value.length === 9) {
            try {
                const address = await buscarCEP(value);
                //console.log("busquei cep", address);

                setFormData({
                    ...formData,
                    cep: value,
                    rua: address.logradouro,
                    bairro: address.bairro,
                    municipio: address.localidade,
                    estado: address.uf
                });
            } catch (error) {
                console.error("Erro ao buscar endereço: ", error);
            }
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        setFormData({ ...formData, email: e.target.value.toLowerCase() });
        if (validateEmail(e.target.value)) {
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        //Testar CPF por precaução:
        if (!validarCPF(formData.cpf)) {
            return;
        }


        try {
            const response = await api.post('/inscricoes/add', formData);
            if (response.data.success) {
                setDialogTitle('Sucesso');
                setDialogMessage('Inscrição realizada com sucesso!');
                setDialogOpen(true);
                setFormData(vazio);
            } else {
                //alert('Erro ao realizar inscrição');
                setDialogTitle('Erro');
                setDialogMessage('Erro ao realizar inscrição');
                setDialogOpen(true);
            }
        } catch (error) {
            console.error('Erro ao enviar inscrição', error);
            //alert('Erro ao enviar inscrição');
            setDialogTitle('Erro');
            setDialogMessage('Erro ao enviar inscrição');
            setDialogOpen(true);
        }


    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <div>
            <div className="App">
                <div className="logo">
                    <Link className="nav-links" to="/login">
                        <img src={logo} alt="SENAI Logo" />
                    </Link>
                </div>
                <h2>Formulário de Inscrição</h2>

            </div>
            <Container maxWidth="md">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Formulário de Inscrição
                    </Typography>
                    <form onSubmit={handleSubmit} id="formFIC">
                        <Grid container spacing={2}>
                            {/*dados do parceiro: empresa e turma*/}
                            {parceiro && (
                                <Grid item xs={4}>

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Turma</InputLabel>
                                    <Select
                                        label="Turma"
                                        name="nomeTurma"
                                        value={formData.nomeTurma}
                                        onChange={handleChange}
                                        required
                                    >
                                        {turmas.map((c) => (
                                            <MenuItem key={c.id} value={c.id}>
                                                {c.descricao}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            )}


                            {/* Dados Pessoais */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Dados Pessoais</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Nome Completo Civil"
                                    name="nomeCivil"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.nomeCivil}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Nome Completo Social"
                                    name="nomeSocial"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.nomeSocial}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <InputMask
                                    mask="99/99/9999"
                                    value={formData.dataNascimento}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Data de Nascimento"
                                            name="dataNascimento"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Documento de Identidade"
                                    name="documentoIdentidade"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.documentoIdentidade}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Órgão"
                                    name="orgao"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.orgao}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>UF</InputLabel>
                                    <Select
                                        label="UF"
                                        name="ufDocumento"
                                        value={formData.ufDocumento}
                                        onChange={handleChange}
                                        required
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <InputMask
                                    mask="999.999.999-99"
                                    value={formData.cpf}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="CPF"
                                            name="cpf"
                                            variant="outlined"
                                            fullWidth
                                            required
                                            error={cpfErro} // Marca o campo como erro se o CPF for inválido
                                            helperText={cpfErro ? 'CPF inválido' : ''} // Exibe uma mensagem de erro
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Sexo</InputLabel>
                                    <Select
                                        label="Sexo"
                                        name="sexo"
                                        value={formData.sexo}
                                        onChange={handleChange}
                                        required
                                    >
                                        {sexos.map((sex) => (
                                            <MenuItem key={sex.value} value={sex.value}>
                                                {sex.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Nacionalidade"
                                    name="nacionalidade"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.nacionalidade}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Naturalidade"
                                    name="naturalidade"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.naturalidade}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>UF</InputLabel>
                                    <Select
                                        label="UF"
                                        name="ufNaturalidade"
                                        value={formData.ufNaturalidade}
                                        onChange={handleChange}
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Pai"
                                    name="pai"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.pai}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Mãe"
                                    name="mae"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.mae}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Etnia</InputLabel>
                                    <Select
                                        label="Etnia"
                                        name="etnia"
                                        value={formData.etnia}
                                        onChange={handleChange}
                                        required
                                    >
                                        {etnias.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Deficiência e Necessidades Educacionais Especiais</InputLabel>
                                    <Select
                                        label="Deficiência e Necessidades Educacionais Especiais"
                                        name="deficiencia"
                                        value={formData.deficiencia}
                                        onChange={handleChange}
                                        required
                                    >
                                        {deficiencias.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Situação Ocupacional */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Situação Ocupacional</Typography>

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Situação Ocupacional</InputLabel>
                                    <Select
                                        label="Situação Ocupacional"
                                        name="situacaoOcupacional"
                                        value={formData.situacaoOcupacional}
                                        onChange={handleChange}
                                        required
                                    >
                                        {ocupacoes.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Endereço */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Endereço</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <InputMask
                                    mask="99999-999"
                                    value={formData.cep}
                                    onChange={handleCepChange}
                                >
                                    {() => (
                                        <TextField
                                            label="CEP"
                                            name="cep"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Rua / Avenida"
                                    name="rua"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.rua}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Nº"
                                    name="numero"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.numero}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Bairro"
                                    name="bairro"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.bairro}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Município"
                                    name="municipio"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.municipio}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Estado</InputLabel>
                                    <Select
                                        label="Estado"
                                        name="estado"
                                        value={formData.estado}
                                        onChange={handleChange}
                                        required
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <InputMask
                                    mask="(99) 9999-9999"
                                    value={formData.telefone}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Telefone"
                                            name="telefone"
                                            variant="outlined"
                                            fullWidth

                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={3}>
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={formData.celular}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Celular"
                                            name="celular"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.email}
                                    onChange={handleEmailChange}
                                    required
                                    error={emailError}
                                    helperText={emailError ? 'Por favor, insira um email válido.' : ''}
                                />
                            </Grid>

                            {/* Escolaridade */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Escolaridade</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Escolaridade</InputLabel>
                                    <Select
                                        label="Escolaridade"
                                        name="escolaridade"
                                        value={formData.escolaridade}
                                        onChange={handleChange}
                                        required
                                    >
                                        {niveisEnsino.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={5}>
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        padding: '1px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box',
                                        height: '56px'
                                    }}
                                >
                                    <FormControl component="fieldset">
                                        {/* Checkbox Concluído */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.concluido}
                                                        onChange={(e) => handleCheckboxChange(e, 'concluido')}
                                                        name="concluido"
                                                        sx={{ marginLeft: '4px', height: '24px' }}
                                                    />
                                                }
                                                label="Concluído no Ano:"
                                                sx={{
                                                    '.MuiFormControlLabel-label': { fontSize: '0.875rem' },
                                                    marginRight: '8px'
                                                }}
                                            />
                                            {/* Campo de Ano para Concluído */}
                                            {formData.concluido && (
                                                <TextField
                                                    name="anoConclusao"
                                                    label='Ano'
                                                    value={formData.anoConclusao || ''}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: '70px', height: '16px' }}
                                                />
                                            )}
                                            {/* Campo de Série para Cursando */}
                                            {formData.cursando && (
                                                <TextField
                                                    name="serieCursando"
                                                    label="Série"
                                                    value={formData.serieCursando || ''}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: '70px', height: '16px' }}
                                                />
                                            )}
                                        </Box>

                                        {/* Checkbox Cursando */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.cursando}
                                                        onChange={(e) => handleCheckboxChange(e, 'cursando')}
                                                        name="cursando"
                                                        sx={{ marginLeft: '4px', height: '24px' }}
                                                    />
                                                }
                                                label="Cursando a Série:"
                                                sx={{
                                                    '.MuiFormControlLabel-label': { fontSize: '0.875rem' },
                                                    marginRight: '8px'
                                                }}
                                            />
                                            
                                        </Box>

                                    </FormControl>

                                </Box>

                            </Grid>
                            <Grid item xs={4}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Tipo Escola</InputLabel>
                                    <Select
                                        label="Tipo Escola"
                                        name="escola"
                                        value={formData.escola}
                                        onChange={handleChange}
                                        required
                                    >
                                        {escolas.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Responsável Legal / Financeiro */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Responsável Legal / Financeiro</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Nome do Responsável Legal / Nome da Empresa"
                                    name="responsavelLegal"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.responsavelLegal}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="CPF / CNPJ"
                                    name="cpfCnpjResponsavel"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.cpfCnpjResponsavel}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mt: 3 }}
                                >
                                    Enviar
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    sx={{ mt: 3 }}
                                    onClick={limparFormulario}
                                >
                                    Limpar formulário
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    <Dialog
                        open={dialogOpen}
                        onClose={handleDialogClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {dialogMessage}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        </div>
    )

}

export default Home;